import React, { ReactElement } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import User from "./pages/user";
import UserHome from "./pages/userHome";
import Receipt from "./pages/receipt";
import App from "./App";
import Login from "./pages/login";
import DirectPay from "./pages/user/DirectPay";

const AppRoutes = (): ReactElement => {
  return (
    <Routes>
      <Route element={<App />}>
        <Route path="/" element={<UserHome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/user" element={<User />} />
        <Route path="/direct/:recipient" element={<DirectPay />} />
        <Route path="/pay/:orderId" element={<User />} />
        <Route path="/receipt/:orderId" element={<Receipt />} />
        {/* 404 路由重定向 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
